import { Link } from "react-router-dom";
import { cn } from "../../utils/format";

export const Logo = ({ className }: { className?: string }) => (
  <Link
    to="/"
    aria-label="Ninja Burger — página inicial"
    className={cn("font-display text-[2rem] leading-none tracking-wider text-white", className)}
  >
    NINJA<span className="text-primary">BURGER</span>
  </Link>
);
